/* @flow */
/* eslint-disable react/no-array-index-key */

import React from 'react';
import _ from 'lodash';
import { Table } from 'reactstrap';

import { createHTMLMarkup } from '../../utils';

// import cx from 'classnames';

// import classes from './ReportInputParams.scss';

// const log = require('bows')('ReportInputParams}');

type PropsType = {
  tableData: Array<[]>,
};
// type StateType = {};

// eslint-disable-next-line react/prefer-stateless-function
export class ReportInputParams extends React.Component<PropsType, *> {
  static defaultProps = {
    tableData: [
      [],
      [],
    ],
  };

  // state: StateType; // eslint-disable-line react/sort-comp
  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    const [selected, ...rest] = this.props.tableData;
    const header = _.first(rest);
    const rows = _.tail(rest);

    const inputRows = rows.map(
      (s, i) => (
        <tr key={i}>
          {s.map((c, j) => <td key={j}>{createHTMLMarkup(c)}</td>)}
        </tr>
      ));

    return (
      <span>
        <Table size="sm" bordered striped>
          <thead>
            <tr>
              <th style={{ borderBottom: 0 }}>{selected}</th>
            </tr>
          </thead>
        </Table>
        <Table size="sm" bordered striped>
          <thead>
            <tr>
              {header.map(s => <th key={s}>{s.replace('s', '')}</th>)}
            </tr>
          </thead>
          <tbody>{inputRows}</tbody>
        </Table>

      </span>
    );
  }
}
export default ReportInputParams;



// WEBPACK FOOTER //
// ./src/components/ReportInputParams/ReportInputParams.js